import React from 'react';
import { BanknotesIcon, ReceiptPercentIcon, WrenchIcon } from '@heroicons/react/24/outline';

const BudgetAllocationCard = () => {
  const stats = [
    {
      id: 1,
      title: "Total Allocated Budget",
      amount: "535,690,195.35",
      icon: <BanknotesIcon className="w-6 h-6 text-teal-600" />,
      bgColor: "bg-teal-50",
      textColor: "text-teal-700",
    },
    {
      id: 2,
      title: "Total Expenditures",
      amount: "159,329,068.10",
      icon: <ReceiptPercentIcon className="w-6 h-6 text-red-600" />,
      bgColor: "bg-red-50",
      textColor: "text-red-700",
    },
    {
      id: 3,
      title: "Budget Utilization Rate",
      amount: "23",
      suffix: "%",
      icon: <WrenchIcon className="w-6 h-6 text-blue-600" />,
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
    },
  ];

  return (
    <div className="bg-white p-8 rounded-2xl shadow-md max-w">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Budget Allocation</h2>
        <p className="text-gray-600 font-semibold">Financial Oversight & Expenditure Tracking</p>
      </div>

      {/* CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stats.map((item) => (
          <div
            key={item.id}
            className={`${item.bgColor} p-6 rounded-xl flex flex-col justify-between min-h-[140px]`}
          >
            <div className="flex items-center gap-3">
              <div>{item.icon}</div>
              <span className="font-semibold text-xl text-gray-700 leading-tight">{item.title}</span>
            </div>

            {/* Amount */}
            <div className="flex justify-end items-baseline gap-1">
              {item.id !== 3 && <span className={`text-xl font-bold ${item.textColor}`}>₱</span>}
              <span className={`text-3xl font-bold ${item.textColor}`}>{item.amount}</span>
              {item.suffix && <span className={`text-xl font-bold ${item.textColor}`}>{item.suffix}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BudgetAllocationCard;
